<template>
<div>
   
    <div class="row">

      <div class="col s3 yo-text-bold">ID</div>
      <div class="col s9">{{item.id}} <!-- {{item.nimv36}} --></div>

      <div v-if="item.vonnumber>0" class="col s3 yo-text-bold">ID VON</div>
      <div v-if="item.vonnumber>0" class="col s9">{{item.vonnumber}} <span v-if="item.vonil!='0000-00-00 00:00:00'">inviato al VON il {{item.vonil  | data('DD MMMM YYYY HH:mm')}}</span></div>

      <div class="col s3 yo-text-bold">SESSO</div>
      <div class="col s9">{{item.sex | answerValue('sex',$teras._variabile)}} </div>

      <div class="col s3 yo-text-bold">DATA DI NASCITA</div>
      <div class="col s9">{{item.datanascita | data('DD MMMM YYYY')}} </div>

      <div class="col s3 yo-text-bold">DATA COMPIMENTO 28 giorno</div>
      <div class="col s9">{{$centro.giorno28(item.datanascita) | data('DD MMMM YYYY')}}</div>

      <div class="col s3 yo-text-bold">DATA COMPIMENTO 36 sett. PMA</div>
      <div class="col s9">{{$centro.settimana36(item.datanascita,item.gaweeks,item.gadays) | data('DD MMMM YYYY')}}</div>

      <div class="col s3 yo-text-bold">PESO ALLA NASCITA</div>
      <div class="col s9">{{item.bwgt}} g</div>

      <div class="col s3 yo-text-bold">ETÀ GESTAZIONALE</div>
      <div class="col s9">{{item.gaweeks}}+{{item.gadays}}</div>

      <div class="col s3 yo-text-bold">SGA</div>
      <div class="col s9">{{item.sga}}</div>

      <div class="col s3 yo-text-bold" v-if="item.los1>0">DURATA RICOVERO (LOS1)</div>
      <div class="col s9" v-if="item.los1>0">{{item.los1}}</div>

      <div class="col s3 yo-text-bold">ULTIMO AGGIORNAMENTO</div>
      <div class="col s9">{{item.modificatoil  | data('DD MMMM YYYY HH:mm')}} </div>


      <div class="col s3 yo-text-bold red" v-if="item.nr_numero>0 && item.chiusoil=='0000-00-00 00:00:00'">DOMANDE NON RISPOSTE</div>
      <div class="col s9 red yo-text-bold yo-text-xxl" v-if="item.nr_numero>10  && item.chiusoil=='0000-00-00 00:00:00'">{{item.nr_numero}} </div>

      
      <div class="col s9 red" v-if="item.nr_numero>0 && item.nr_numero<11">
        <ol style="margin:0;padding: 0 0 0 24px;">
        <li v-for="(singleName,index) in item.nr_nome.split(',')" :key="index" v-html="labelName(singleName)" v-if="singleName!='neggdigiuno'"></li>

        <li v-if="item.negg+item.digiuno!=item.los1 && item.negg>-1 && item.digiuno>-1">Verificare il numero di giorni di nutrizione {{item.negg+item.digiuno}} perchè non coerenti con la durata del ricovero {{item.los1}} </li>
        </ol>
        <!-- {{item.nr_nome}}  {{labelName}}-->
      </div>

      <div class="col s3 yo-text-bold" v-if="item.chiusoil!='0000-00-00 00:00:00'">SCHEDA CHIUSA</div>
      <div class="col s9" v-if="item.chiusoil!='0000-00-00 00:00:00'">{{item.chiusoil  | data('DD MMMM YYYY HH:mm')}} </div>

   </div>

   <div class="row" style="margin-top:12px;border-top:1px solid #5288C6;" >
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-datigenerali/'+item.id" ><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >folder_open</i>DATI GENERALI</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-perinatale/'+item.id" ><img src="../assets/ico-perinatale.png" class="material-icons " style="float:left;padding:0 8px 0 14px;height:24px;" />DATI PERINATALI</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-salaparto/'+item.id" ><img src="../assets/ico-salaparto.png" class="material-icons " style="float:left;padding:0 8px 0 14px;height:24px;" />SALA PARTO</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-decorso/'+item.id" ><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >hotel</i>DECORSO CLINICO</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-dimissione/'+item.id" ><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >child_friendly</i>DIMISSIONE</router-link>
      </div>
      <div class="col s2" style="margin-top:12px;" v-if="item.fdisp==2">
        <router-link class="button yo-color-primary yo-text-bold" :to="'/scheda-trasferimento/'+item.id" ><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >directions_bus</i>TRASFERIMENTO</router-link>
      </div>
   </div>



   <div class="row" style="margin-top:12px;border-top:1px solid #5288C6;padding-top:12px;border-bottom:1px solid #5288C6;padding-bottom:12px;" v-if="item.chiusoil!='0000-00-00 00:00:00'">
    <div class="col s12 m10 yo-text-n">
          <div class="yo-text-m tree_poppy" style="margin-bottom:6px;">Complimenti, la scheda paziente è chiusa!</div>
          In caso di assoluta necessità puoi riaprire la scheda per modificare i dati errati.
          </div>
    <div class="col s12 m2 yo-align-right">
      <div v-on:click="rowOpen" class="yo-button tree_poppy yo-text-bold" style="padding:18px 32px 0 0;"><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >lock_open</i>APRI</div>
    </div>
   </div>

   <div class="row" style="margin-top:12px;border-top:1px solid #5288C6;padding-top:12px;border-bottom:1px solid #5288C6;padding-bottom:12px;" v-if="item.nr_numero==0 && item.chiusoil=='0000-00-00 00:00:00'">
    <div class="col s12 m10 yo-text-n">
          <div class="yo-text-m green" style="margin-bottom:6px;">Complimenti, la scheda paziente è completa!</div>
          Ora puoi procedere con il suo invio. Se hai verificato tutti i dati puoi chiudere la scheda cliccando il pulsante invia
          </div>
          <div class="col s12 m2 yo-align-right">
            <div v-on:click="rowSend" class="yo-button green yo-text-bold" style="padding:18px 32px 0 0;"><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >send</i>INVIA</div>
    </div>
   </div>



   <div class="row" style="margin-top:12px;border-top:1px solid #5288C6;padding-top:12px;border-bottom:1px solid #5288C6;padding-bottom:12px;" v-if="item.chiusoil=='0000-00-00 00:00:00'">
    <div class="col s12 m10 yo-text-n">
          In caso di assoluta necessità è possibile cancellare il paziente.
          </div>
    <div class="col s12 m2 yo-align-right">
      <div v-on:click="rowDel" class="yo-button tree_poppy yo-text-bold" style="padding:18px 32px 0 0;"><i class="material-icons " style="float:left;padding:0 8px 0 14px;" >delete</i>CANCELLA</div>
    </div>
   </div>

</div>
</template>


<script>
import dbItem from '../teras/dbItem'
export default {
  name: 'item-elenco',
  created () {
    this.$teras.pageHeader = 80
  },
  mounted () {
    this.$emit('scrollTop', 0)
  },
  props: {
    item: Object
  },
  methods: {
    rowSend () {
      this.$confirm('La scheda del paziente "'+this.item.cognome+' '+this.item.nome+'" verrà chiusa e inviata, confermi?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        let item2send = new dbItem({table:'paziente'})
        await item2send.load(this.item.id)
        item2send.row.chiusoil=this.$moment().format('YYYY-MM-DD H:mm:ss')
        item2send.row.chiusoda=this.$centro.referente.row.id
        await item2send.save()
        await this.$centro.getPaziente()

        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })
      
    },
    rowOpen () {
      this.$confirm('La scheda del paziente "'+this.item.cognome+' '+this.item.nome+'" verrà riaperta, confermi?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        let item2open = new dbItem({table:'paziente'})
        await item2open.load(this.item.id)
        item2open.row.vonil='0000-00-00 00:00:00'
        item2open.row.chiusoil='0000-00-00 00:00:00'
        item2open.row.chiusoda=''
        await item2open.save()
        let pazienteRiapertura = new dbItem({table:'paziente_riapertura'})
        await pazienteRiapertura.new()
        pazienteRiapertura.row.vonil=this.item.vonil
        pazienteRiapertura.row.chiusoil=this.item.chiusoil
        pazienteRiapertura.row.paziente=this.item.id
        pazienteRiapertura.row.giorno=this.$moment().format('YYYY-MM-DD H:mm:ss')
        pazienteRiapertura.row.contatto=this.$centro.referente.row.id
        await pazienteRiapertura.save()
        await this.$centro.getPaziente()

        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })
      
    },
    rowDel () {
      this.$confirm('La scheda del paziente "'+this.item.cognome+' '+this.item.nome+'" verrà eliminata, confermi?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        await this.$axios.query('doQuery',`UPDATE paziente SET id=id*-1 WHERE id=←id`,{id: this.item.id})  
        await this.$centro.getPaziente()
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })
      
    },
    loadScheda(scheda) {
        this.$router.push('/scheda-'+scheda+'/'+this.item.id)


        
    },
    socioNew() {
      this.$confirm('Sei sicuro di inserire come nuovo socio:'+this.item.cognome+' '+this.item.nome+'?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        await this.$axios.query('doQuery',`INSERT INTO statoiscrizione (contatto,societa,stato,tiposocio,inseritoil,primoanno) VALUES(←id,←societa,'DA APPROVARE',1,→inseritoil,→primoanno)`,{id: this.item.id, societa: this.$socio.societa, inseritoil:this.$moment(),primoanno: this.$moment().format('YYYY')})  
        this.$socio.contatto.load(this.item.id).then((data) => {
          this.$teras.socio = true
          this.$router.push('/home')
        })
        
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })

        
    },
    labelName(nome){
      let label =  (this.$teras.getItemFromArrayObject(nome,'nome',this.$teras._variabile)).domanda
      return label
    }
  }
}
</script>

<style>
.evento-title{font-size:1.6rem;font-weight:bold;color:#003264;
}.row-item{
  margin:0 0 10px 0;
}.row-item .title{
  color:#29B7C4;
  line-height: 1.4rem;
  font-size: 1.4rem;
  padding:0;
}.row-item .autori{
  line-height: 1.1rem;
  font-size: 1.2rem;
  padding-top:2px;
  text-transform: capitalize;
  text-align: left;
}.row-item .codice{
  font-size:1.1rem;
  padding-top:10px;
}.el-table__expanded-cell{
   padding:0 0 32px 16px !important;
}
</style>
